/* Token pozvánky do týmu přes přihlášení (hlavně SSO).
 * ============================================================================
 * SSO (OAuth i /sso) po přihlášení vrací na „/“ — cíl odkazu /pozvanka/:token
 * by se ztratil. Stránka pozvánky proto PŘED odchodem na přihlášení uloží token
 * do sessionStorage a RootRedirect (App.js) po návratu doveze člověka zpátky.
 *
 * Bezpečnost (žádné otevřené přesměrování):
 *  · ukládá se JEN token, který projde TOKEN_RE (znaky URL-safe base64),
 *  · cestu /pozvanka/<token> skládá volající sám — z úložiště se nikdy nečte URL,
 *  · platnost 2 hodiny, poškozený záznam se smaže.
 */
export const TOKEN_RE = /^[A-Za-z0-9_-]{16,64}$/;
export const KLIC_POZVANKY = "beplan.pozvanka";
export const PLATNOST_MS = 2 * 60 * 60 * 1000;

export function jePlatnyToken(token) {
  return typeof token === "string" && TOKEN_RE.test(token);
}

export function ulozPozvanku(token, ted = Date.now()) {
  if (!jePlatnyToken(token)) return false;
  try {
    window.sessionStorage.setItem(KLIC_POZVANKY, JSON.stringify({ token, ulozeno: ted }));
    return true;
  } catch {
    return false;
  }
}

export function zapomenPozvanku() {
  try { window.sessionStorage.removeItem(KLIC_POZVANKY); } catch { /* noop */ }
}

/** Platný uložený token, jinak null (a vadný / prošlý záznam smaže). */
export function prectiPozvanku(ted = Date.now()) {
  let surove = null;
  try { surove = window.sessionStorage.getItem(KLIC_POZVANKY); } catch { return null; }
  if (!surove) return null;
  try {
    const z = JSON.parse(surove);
    const stari = ted - Number(z && z.ulozeno);
    if (z && jePlatnyToken(z.token) && Number.isFinite(stari) && stari >= 0 && stari <= PLATNOST_MS) {
      return z.token;
    }
  } catch { /* poškozený JSON */ }
  zapomenPozvanku();
  return null;
}

/** Cesta na stránku pozvánky — token jen v cestě, nikdy v ? ani #. */
export function cestaPozvanky(token) {
  return jePlatnyToken(token) ? `/pozvanka/${token}` : null;
}
